import {Component, OnInit, Input} from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import {ConfigService } from 'app/services';
import {MenuHomeEnum} from 'app/home';
import {CampaignUsersService} from 'app/services/campaign-users.service';

@Component({
    selector: 'campaign-users-root',
    templateUrl: './campaign-users-root.component.html',
    styleUrls: ['./campaign-users-root.component.scss',
        '../../../../styles/paginator.scss'],
    providers: [MessageService]
})

export class CampaignUsersRootComponent implements OnInit {
    @Input()
    public menuPermissionActive!: string;

    singleCompanyWallet: any = undefined;
    menuHomeEnumActive: MenuHomeEnum = MenuHomeEnum.CampaignUsers_Users;
    campaignUsersTabMenu: any = [
        {
            name: 'Campaign Users',
            value: MenuHomeEnum.CampaignUsers_Users
        },
        {
            name: 'Transactions',
            value: MenuHomeEnum.CampaignUsers_Transactions
        }
    ];
    _menuHomeEnum = MenuHomeEnum;
    public breadcrumbs: MenuItem[] = [{ icon: 'icon_back_office' }, { label: 'Application' }, { label: 'Users' }, { label: 'Campaign Users' }];

    constructor(
        private messageService: MessageService,
        private campaignUsersService: CampaignUsersService,
        public configService: ConfigService
        ) {
    }

    ngOnInit(): void {
        this.getSingleCompanyWallet();
    }

    clickChangeMenuHomeActive(value: MenuHomeEnum) {
        this.menuHomeEnumActive = value;
    }

    getSingleCompanyWallet() {
        const dto = {};
        this.campaignUsersService.getSingleCompanyWallet(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.singleCompanyWallet = data?.SingleCompanyWallet;
            });

    }
}
